export const GET_MEMO = "GET_MEMO"
export const GET_MEMO_SUCCESS = "GET_MEMO_SUCCESS"
export const GET_MEMO_FAIL = "GET_MEMO_FAIL"

export const API_ERROR = "API_ERROR"
